<template>
  <div
    class="container-fluid"
    style="
      background-image: url('./Image/back.jpg');
      background-size: cover;
      height: 100vh;
    "
  >
    <loading v-if="loadingRender"></loading>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8 mt-md-5 p-md-5">
        <net-pa-card v-if="stage == 1">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-unlock"></i> بازیابی
              <span class="float-left" @click="$router.go(-1)">
                <i
                  data-v-9331d9a2=""
                  title="بازگشت به صفحه قبلی"
                  class="fas fa-arrow-left text-light Pointer"
                  style="float: left; font-size: 18px"
                ></i
              ></span>
            </h6>
          </template>
          <template slot="content">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <h6>
                    <span class="text-secondary">
                      برای دریافت پیامک بازیابی رمز عبور:</span
                    >

                    کد ملی و شماره موبایل ثبت شده در سیستم را وارد کنید.
                  </h6>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <form id="div1" class="w-100">
                    <div class="row">
                      <div class="col-3"></div>

                      <div class="col-md-6 col-12 row">
                        <div class="col-12 p-2">
                          <input
                            class="form-control text-center mt-2 required"
                            style="direction: ltr"
                            type="number"
                            v-model="Codemeli"
                            placeholder="کد ملی"
                            @keypress="$BlockSuspiciousInput($event, 11)"
                            @keyup="$BlockSuspiciousInput($event, 12)"
                          />
                        </div>
                        <div class="col-12 p-2">
                          <input
                            class="form-control text-center required mt-2"
                            style="direction: ltr"
                            type="number"
                            v-model="mobile"
                            placeholder="شماره موبایل "
                            @keypress="$BlockSuspiciousInput($event, 11)"
                            @keyup="$BlockSuspiciousInput($event, 12)"
                          />
                        </div>
                      </div>
                      <div class="col-3"></div>
                      <div class="col-3"></div>
                      <div class="col-md-6 col-12 row">
                        <div class="col-12 p-2">
                          <CaptchaBox
                            ref="captchaRef"
                            @update="onCaptchaValid"
                          ></CaptchaBox>
                          <!-- <div class="rounded bg-light border p-2">
                                                    <vue-recaptcha-eh v-on:getValidation="Validation" :option="option">
                                                    </vue-recaptcha-eh>
                                                </div> -->

                          <button
                            :disabled="!CaptchaValid"
                            class="btn btn-submit w-100 mt-2"
                            @click.prevent="sendSms"
                          >
                            ارسال پیامک بازیابی
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-3"></div>
                  </form>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>

        <net-pa-card v-if="stage == 2">
          <template slot="header">
            <h6 class="text-right"><i class="fas fa-unlock"></i> تغییر رمز</h6>
          </template>
          <template slot="content">
            <div class="row p-3">
              <div class="col-12">
                <h6>کد پیامک شده و رمز عبور جدید خود را وارد کنید</h6>
              </div>
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12">
                <form id="divpass">
                  <div class="row">
                    <div class="col-12 m-2">
                      <input
                        type="number"
                        placeholder="کد یکبار مصرف"
                        class="form-control text-center required"
                        style="direction: ltr"
                        v-model="yekbarRamz"
                        autocomplete="off"
                      />
                    </div>
                    <div class="col-12 m-2">
                      <input
                        :type="showPass ? 'text' : 'password'"
                        placeholder="رمز عبور جدید"
                        class="form-control text-center required required-Pass"
                        style="direction: ltr"
                        v-model="newPass"
                        @keypress="$BlockSuspiciousInput($event, 30)"
                        autocomplete="new-password"
                      />
                      <span @click="showPass = !showPass" class="toggle-eye">
                        <i v-if="showPass" class="fa fa-eye-slash"></i>
                        <i v-else class="fa fa-eye"></i>
                      </span>
                    </div>
                    <div class="col-12 m-2">
                      <input
                        :type="showPass2 ? 'text' : 'password'"
                        placeholder="تکرار رمز عبور"
                        class="form-control text-center required required-Pass"
                        style="direction: ltr"
                        v-model="NewPassRepeat"
                        @keypress="$BlockSuspiciousInput($event, 30)"
                        @keyup="$BlockSuspiciousInput($event, 30)"
                        autocomplete="new-password"
                      />
                      <span @click="showPass2 = !showPass2" class="toggle-eye">
                        <i v-if="showPass2" class="fa fa-eye-slash"></i>
                        <i v-else class="fa fa-eye"></i>
                      </span>
                    </div>
                    <div class="col-12 mt-2">
                      <div class="col-12 mt-2">
                        <CaptchaBox
                          ref="captchaRef"
                          @update="onCaptchaValid"
                        ></CaptchaBox>
                      </div>
                      <button
                        :disabled="!CaptchaValid"
                        class="btn w-100 btn-submit"
                        @click.prevent="changepass"
                      >
                        تغییر رمز
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-3"></div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";

import loading from "../Tools/NetPa/Loading.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";
// import VueRecaptchaEh from "vue-recaptcha-eh";
export default {
  components: { NetPaCard, loading, CaptchaBox },
  data() {
    return {
      showPass: false,
      showPass2: false,
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      mobile: "",
      Codemeli: "",
      stage: 1,
      validation: false,
      NewPassRepeat: "",
      newPass: "",
      yekbarRamz: "",
      loadingRender: false,
    };
  },
  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    sendSms() {
      if (this.$ValidForm("div1")) {
        if (this.Codemeli == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " کد ملی نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.mobile == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.mobile.length != 11) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه 11 رقمی است.",
            "error",
            2000,
          );
          return;
        } else {
          this.loadingRender = true;
          var DataAxiosForget = {
            ArryfildValue: {},
            Action: "Bazyabi/RememberPass",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append("mobile", this.mobile);
          formData.append("codeMeli", this.Codemeli);
          formData.append("userInput", this.captchaText);
          formData.append("captchaId", this.captchaId);
          DataAxiosForget.ArryfildValue = formData;
          this.$PostFormData(DataAxiosForget).then((data) => {
            this.$mySweetDefaultTost(" ", data.msg, data.icone, 3000);
            if (data.status == "Ok") {
              this.stage = 2;
              this.loadingRender = false;
              this.CaptchaValid = false;
            } else {
              this.refreshCaptcha();
              this.stage = 1;
              this.loadingRender = false;
            }
          });
        }
      }
    },
    changepass() {
      if (this.$ValidForm("divpass")) {
        this.loadingRender = true;
        if (this.newPass == this.NewPassRepeat) {
          var DataAxiosChangePass = {
            ArryfildValue: {},
            Action: "Bazyabi/UpdatePass",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append(
            "AxarinTaghirPass",
            this.$store.state.JalaliDateAndTime,
          );
          formData.append("newPass", this.newPass);
          formData.append("randomKey", this.yekbarRamz);
          formData.append("codeMeli", this.Codemeli);
          formData.append("CustomerCode", this.$session.get("CustCode"));
          formData.append("userInput", this.captchaText);
          formData.append("captchaId", this.captchaId);
          DataAxiosChangePass.ArryfildValue = formData;
          this.$PostFormData(DataAxiosChangePass).then((data) => {
            this.$mySweetDefaultTost(" ", data.msg, data.icone, 2000);
            if (data.status == "Ok") {
              this.$router.go(-1);
            } else {
              this.refreshCaptcha();
              this.loadingRender = false;
              this.stage = 2;
            }
          });
        } else {
          this.$mySweetDefaultTost(
            " خطا",
            "رمز عبور وارد شده و تکرارش برابر نیستند!",
            "error",
            2000,
          );
          return;
        }
      }
    },
    checkregex(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!/^[A-Za-z0-9]+$/.test(char)) {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف انگلیسی و اعداد  مجاز هستند",
          "error",
          2000,
        );
        e.preventDefault();
      }
    },
  },
  mounted() {
    this.NewPassRepeat = "";
    this.newPass = "";
    this.yekbarRamz = "";
  },
};
</script>
<style scoped>
.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(
    301deg,
    rgba(145, 124, 193, 1) 0%,
    rgba(72, 20, 193, 1) 100%
  );
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}
.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
<style>
input.inputValidetaEh {
  width: 100% !important;
}

input.inputValidetaEh {
  display: block !important;
  width: 100% !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #495057 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.LeftsideValideta {
  float: none !important;
}
.toggle-eye {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #555;
  font-size: 18px;
}
</style>
